import BankAcccountVerification from "./BankAccountVerification";

export default BankAcccountVerification;
